import { useParams, useNavigate } from "react-router-dom";
import React, { useState, useContext, useEffect, useCallback } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { AppContext } from "../../../../context/AppContext";
import Swal from "sweetalert2";
import axios from "axios";
import GetToken from "../../../../GetToken";
import { handleInvalidToken } from "../../../../AuthUtils";
import AnimationSpinner from "../../../../AnimationSpinner";
import Select from "react-select";
import Accordion from "react-bootstrap/Accordion";

// for micro animation of switch button
import { motion, AnimatePresence } from "framer-motion";

// react icons import
import { IoIosArrowRoundBack, IoIosArrowRoundForward } from "react-icons/io";
import { FaRegPlusSquare } from "react-icons/fa";

//import for react drag and drop
import { toast } from "react-toastify";
import { useDropzone } from "react-dropzone";

// switch button import
import { styled } from "@mui/material/styles";
import Switch from "@mui/material/Switch";

// mui color picker import
import { MuiColorInput } from "mui-color-input";

// avatar image
import dummyAvatarImage from "../../../../assets/images/avatar/pngwing.com.png";
import selectedImage from "../../../../assets/images/check.png";

// Material UI import
import Button from "@mui/material/Button";
import { RiEditBoxLine } from "react-icons/ri";
import { MdClose, MdPublish } from "react-icons/md";
import { HiMiniSpeakerWave } from "react-icons/hi2";

// custom component import
import TalkingBookStepper from "../TalkingBookStepper";

// importing utility functions
import { truncateTextByChars } from "../../../../util";

const Android12Switch = styled(Switch)(({ theme }) => ({
	padding: 8,
	"& .MuiSwitch-track": {
		borderRadius: 22 / 2,
		"&::before, &::after": {
			content: '""',
			position: "absolute",
			top: "50%",
			transform: "translateY(-50%)",
			width: 16,
			height: 16,
		},
		"&::before": {
			backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
				theme.palette.getContrastText(theme.palette.primary.main)
			)}" d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"/></svg>')`,
			left: 12,
		},
		"&::after": {
			backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
				theme.palette.getContrastText(theme.palette.primary.main)
			)}" d="M19,13H5V11H19V13Z" /></svg>')`,
			right: 12,
		},
	},
	"& .MuiSwitch-thumb": {
		boxShadow: "none",
		width: 16,
		height: 16,
		margin: 2,
	},
}));

const AvatarCard = React.memo(({ col, avatar, handleAvatarSelection, base_url }) => {
	const avatarImageUrl = avatar.image.startsWith("http") ? avatar.image : base_url + avatar.image;
	return (
		<div className={`col-md-${col} mb-3`}>
			<div onClick={() => handleAvatarSelection(avatar)} className={`card avatar-card pointer ${avatar.isSelected ? "active" : ''} `}>
				{avatar.type !== "dfy" && <div className="avatar-badge">
					<span className="avatar-badge_span">Custom</span>
				</div>}
				<div className="avatar-img-container" style={{ width: '100%', height: '185px', overflow: 'hidden' }}>
					<img src={avatarImageUrl} alt="Avatar" className="avatar-img" style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
				</div>
				{avatar.isSelected &&
					<div className="select-icon-container">
						<img className="selected-icon" src={selectedImage} alt="Selected" />
					</div>}
			</div>
		</div>
	)
})
const AvatarPage = ({ steps, activeStep, setActiveStep, bookToken }) => {
	const [enableAudio, setEnableAudio] = useState(false);
	const [enableAvatar, setEnableAvatar] = useState(false);
	const [loading, setLoading] = useState(false);
	const { base_url } = useContext(AppContext);
	const navigate = useNavigate();
	const [bookDetail, setBookDetail] = useState("");
	const [voices, setVoices] = useState([]);
	const [avatars, setAvatars] = useState([]);
	const [avatarPage, setAvatarPage] = useState(1);
	const [avatarLimit, setAvatarLimit] = useState(8);
	const [hasMoreAvatarLoadMore, setHasMoreAvatarLoadMore] = useState(false);
	const [voicePreviewModelActive, setVoicePreviewModelActive] = useState(false);

	const avatarConfig = useFormik({
		initialValues: {
			selectedAvatar: '',
			voice: '',
		},

		onSubmit: async (values) => {
			const token = GetToken();
			if (!token) {
				handleInvalidToken(navigate);
				return;
			}

			setLoading(true);
			const formData = new FormData();
			Object.entries(values).forEach(([key, value]) =>
				formData.append(key, value)
			);
			formData.append("speed", bookDetail?.speed || 1);
			formData.append("pitch", bookDetail?.pitch || 0);
			formData.append("volumeGain", bookDetail?.volume_gain || 0);
			formData.append("textColor", bookDetail?.text_color || "#000000");
			formData.append("textBackgroundColor", bookDetail.text_background_color || "#ffffff");
			formData.append("textBold", bookDetail?.text_bold || false);;
			formData.append("token", token);
			formData.append("action", "publishTalkingBook");
			formData.append("book_token", bookToken);
			formData.append("enable_audio", (enableAudio == true) ? 1 : 0);
			formData.append("enable_avatar", (enableAvatar == true) ? 1 : 0);

			if (enableAvatar == true && values.selectedAvatar == "") {
				setLoading(false);
				toast.warning("Please select an avatar before proceeding.");
				return;
			}

			if (enableAudio && values.voice == "") {
				setLoading(false);
				toast.warning("Please select a voice before proceeding.");
				return;
			}

			try {
				const response = await axios.post(`${base_url}api/user/book`, formData);
				setLoading(false);

				if (response.data.status) {
					toast.success("Your book has been published successfully.");
					setTimeout(() => {
						navigate(`/book/manage/talking_book`);
					}, 1000);

				} else {
					if (response.data.reset) {
						handleInvalidToken(navigate);
						return;
					}
					toast.warning(response.data.message);
				}
			} catch (error) {
				setLoading(false);
				toast.error(error.response?.data?.message || error.message ||
					"Something went wrong. Please try again.")
			}
		},
	});

	const fetchPageData = async () => {
		try {
			const token = GetToken();
			if (!token) {
				handleInvalidToken(navigate);
				return;
			}
			setLoading(true);
			const formData = new FormData();
			formData.append("action", "getBookVoice");
			formData.append("token", token);
			formData.append("book_token", bookToken);

			const response = await axios.post(`${base_url}api/user/book`, formData);

			if (response.data.status) {
				const fetchedVoices = response.data.voices || [];
				const fetchedBookDetail = response.data.bookDetail;
				setVoices(fetchedVoices);
				setBookDetail(fetchedBookDetail);
				var defaultVoice = (fetchedBookDetail.voice != '') ? fetchedBookDetail.voice : fetchedVoices[0].ids;
				avatarConfig.setValues({ ...avatarConfig.values, voice: defaultVoice });

				if (
					fetchedBookDetail.enable_book_audio == 1 ||
					fetchedBookDetail.enable_book_audio == "1"
				) {
					setEnableAudio(true);
				}
				if (
					fetchedBookDetail.enable_avatar == 1 ||
					fetchedBookDetail.enable_avatar == "1"
				) {
					setEnableAvatar(true);
				}
				setTimeout(() => {
					setLoading(false);
				}, 1500);
			} else {
				setLoading(false);
				if (response.data.reset) {
					handleInvalidToken(navigate);
					return;
				}
				toast.warning(response.data.message);

			}
		} catch (error) {
			setLoading(false);
			toast.error(error.response?.data?.message ||
				error.message ||
				"Something went wrong. Please try again.",)
		}
	};

	useEffect(() => {
		fetchPageData();
	}, []);

	const fetchAvatar = async () => {
		try {
			const token = GetToken();
			if (!token) {
				handleInvalidToken(navigate);
				return;
			}
			setLoading(true);
			const formData = new FormData();
			formData.append("action", "getBookAvatar");
			formData.append("token", token);
			formData.append("book_token", bookToken);
			formData.append("limit", avatarPage == 1 ? avatarLimit : avatarLimit + 1);
			formData.append("page", avatarPage);

			const response = await axios.post(`${base_url}api/user/book`, formData);

			if (response.data.status) {
				const fetchedAvatars = response.data.avatars || [];
				const alreadySelectedAvatar = bookDetail.avatar
				const mappedAvatars = fetchedAvatars.map(avatar => ({
					...avatar,
					isSelected: avatar.ids === alreadySelectedAvatar
				}));
				setAvatars((prevAvatars) => [...prevAvatars, ...mappedAvatars]);
				setHasMoreAvatarLoadMore(response.data.has_more);
				if (avatarPage === 1 && fetchedAvatars.length > 0) {
					var defaultAvatar = bookDetail.avatar || fetchedAvatars[0].ids;
					avatarConfig.setValues({ ...avatarConfig.values, selectedAvatar: defaultAvatar });
				}

				setTimeout(() => {
					setLoading(false);
				}, 1500);
			} else {
				setLoading(false);
				if (response.data.reset) {
					handleInvalidToken(navigate);
					return;
				}
				toast.warning(response.data.message);
			}
		} catch (error) {
			setLoading(false);
			toast.error(error.response?.data?.message ||
				error.message ||
				"Something went wrong. Please try again.",)
		}
	};

	useEffect(() => {
		if (enableAvatar) {
			fetchAvatar();
		}
	}, [enableAvatar, avatarPage]);



	const onDrop = useCallback(async (acceptedFiles) => {
		const file = acceptedFiles[0];
		if (file) {
			if (file.size > 5 * 1024 * 1024) {
				toast.error(
					"The file is too large. Please upload a file that is 5MB or smaller."
				);
				return;
			}

			const image = new Image();
			const reader = new FileReader();

			reader.onload = (e) => {
				image.src = e.target.result;
			};

			image.onload = async () => {
				const aspectRatio = image.height / image.width;
				const expectedRatio = 16 / 9;

				if (
					aspectRatio < expectedRatio - 0.05 ||
					aspectRatio > expectedRatio + 0.05
				) {
					toast.error(
						"Please upload a portrait image with a 9:16 aspect ratio."
					);
					return;
				}

				const result = await Swal.fire({
					title: "Confirm Selection",
					text: "Do you want to upload this avatar?",
					icon: "question",
					showCancelButton: true,
					confirmButtonColor: "#3085d6",
					cancelButtonColor: "#d33",
					confirmButtonText: "Yes, upload it!",
				});

				if (result.isConfirmed) {
					try {
						const token = GetToken();
						if (!token) {
							handleInvalidToken(navigate);
							return;
						}
						setLoading(true);
						const formData = new FormData();
						formData.append("action", "uploadCustomAvatar");
						formData.append("token", token);
						formData.append("customAvatar", file);

						const response = await axios.post(
							`${base_url}api/user/book`,
							formData
						);

						if (response.data.status) {
							fetchAvatar();
						} else {
							setLoading(false);
							if (response.data.reset) {
								handleInvalidToken(navigate);
								return;
							}
							toast.warning(response.data.message);
						}
					} catch (error) {
						setLoading(false);
						toast.error(error.response?.data?.message ||
							error.message ||
							"Something went wrong. Please try again.",)

					}
				}
			};

			reader.readAsDataURL(file);
		}
	}, []);

	const { getRootProps, getInputProps, isDragActive } = useDropzone({
		onDrop,
		maxFiles: 1,
		//maxSize: 10 * 1024 * 1024,
		accept: {
			"image/png": [".png"],
			"image/jpeg": [".jpg", ".jpeg"],
		},

		onDropRejected: (fileRejections) => {
			fileRejections.forEach(({ file, errors }) => {
				errors.forEach((error) => {
					toast.error("Image type can be only .jpg, .jpeg and .png");
				});
			});
		},
	});

	useEffect(() => {
		avatarConfig.setFieldValue("textBold", bookDetail?.text_bold);
	}, [bookDetail?.text_bold]);

	useEffect(() => {
		avatarConfig.setFieldValue("textColor", bookDetail.text_color);
		avatarConfig.setFieldValue("textBackgroundColor", bookDetail.text_background_color);
	}, [bookDetail.text_color, bookDetail.text_background_color]);

	useEffect(() => {
		if (!enableAudio) {
			setEnableAvatar(false);
		}
	}, [enableAudio]);

	const handleAvatarSelection = useCallback((selectedAvatar) => {
		const previouslySelected = avatars.find(
			(option) => option.isSelected === true
		);
		if (previouslySelected) {
			previouslySelected.isSelected = false;
		}
		const newSelected = avatars.find(
			(option) => option.ids === selectedAvatar.ids
		);
		avatarConfig.setFieldValue("selectedAvatar", selectedAvatar.ids);
		newSelected.isSelected = true;
	});

	const updateTrackStyle = (input, min, max) => {
		let percentage = ((input.value - min) / (max - min)) * 100;
		input.style.setProperty("--progress", percentage + "%");
	};
	const closeModel = () => {
		setVoicePreviewModelActive(false);
	};
	useEffect(() => {
		const rightContainer = document.querySelector(".right-container");
		if (voicePreviewModelActive) {
			rightContainer.style.overflow = "hidden";
		} else {
			rightContainer.style.overflow = "auto";
		}
		return () => {
			rightContainer.style.overflow = "auto";
		};
	}, [voicePreviewModelActive]);

	const handleBack = () => {
		if (activeStep > 0) {
			setActiveStep((prevActiveStep) => prevActiveStep - 1);
		}
	};
	const handleLoadMoreAvatar = () => {
		setAvatarPage((prevPage) => prevPage + 1);
	};

	const handleTextColorChange = (newValue) => {
		// avatarConfig.setFieldValue("textColor", newValue);
		setBookDetail({ ...bookDetail, text_color: newValue });
	}
	const handleBgColorChange = (newValue) => {
		// avatarConfig.setFieldValue("textBackgroundColor", newValue);
		setBookDetail({ ...bookDetail, text_background_color: newValue });
	}
	const handleBold = (e) => {
		// avatarConfig.setFieldValue("textBold", e.target.checked);
		setBookDetail({ ...bookDetail, text_bold: e.target.checked ? "true" : "false" });
	}


	return (
		<>
			<AnimationSpinner show={loading} />
			<div className="row align-items-center">
				<div className="col-lg-6 page-title-container">
					<h4 className="fw-semibold mb-1">
						{bookDetail.title
							? truncateTextByChars(bookDetail.title, 45)
							: "Loading..."}
					</h4>
					<p className="mb-1">Choose your preferred book index </p>
				</div>
				<div className="col-lg-6 justify-content-end">
					<div className="d-flex justify-content-end gap-4">
						<Button
							onClick={handleBack}
							variant="contained"
							color="secondary"
							title="Go Back"
							className="ms-2"
							sx={{
								minWidth: "35px",
								height: "38px",
								padding: "0 17px",
							}}
						>
							<IoIosArrowRoundBack size={30} fontWeight={600} color="white" />
							Back
						</Button>
						<Button
							onClick={avatarConfig.handleSubmit}
							variant="contained"
							color="secondary"
							title="Publish Book"
							className="ms-2"
							sx={{
								minWidth: "35px",
								height: "38px",
								padding: "0 17px",
							}}
						>
							<MdPublish size={18} fontWeight={600} color="white" style={{ marginRight: "10px" }} />
							Publish Your Book
						</Button>
					</div>
				</div>
			</div>

			<div className="my-4">
				<TalkingBookStepper steps={steps} activeStep={activeStep} />
			</div>

			<div className="row my-4">
				{enableAudio && (
					<div className="col-md-8 d-flex">
						<div>
							<label htmlFor="enableAudio">Want to enable audio</label>
							<Android12Switch
								id="enableAudio"
								name="enableAudio"
								checked={enableAudio}
								onChange={(e) => setEnableAudio(e.target.checked)}
							/>
						</div>
						{enableAudio && enableAvatar && (
							<AnimatePresence mode="wait">
								<motion.div
									className="row g-4"
									initial={{ opacity: 0, scale: 0.8 }}
									animate={{ opacity: 1, scale: 1 }}
									exit={{ opacity: 0, scale: 0.8 }}
									transition={{ duration: 0.5 }}
								>
									<div className="ms-4">
										<label htmlFor="enableAvatar">Want to enable Avatar</label>
										<Android12Switch
											id="enableAvatar"
											name="enableAvatar"
											checked={enableAvatar}
											onChange={(e) => setEnableAvatar(e.target.checked)}
										/>
									</div>
								</motion.div>
							</AnimatePresence>
						)}
					</div>
				)}
			</div>
			<div className="row">
				<div className="col-md-6">
					<div className="overlay-enable">
						<AnimatePresence>
							{!enableAudio && (
								<>
									<motion.div
										className="button_audio-enable"
										initial={{ opacity: 0, y: -10 }}
										animate={{ opacity: 1, y: 0 }}
										exit={{ opacity: 0, y: -10 }}
										transition={{ duration: 0.8 }}
									>
										<label htmlFor="enableAudio">Want to enable audio</label>
										<Android12Switch
											id="enableAudio"
											name="enableAudio"
											checked={enableAudio}
											onChange={(e) => setEnableAudio(e.target.checked)}
										/>
									</motion.div>

									<motion.div
										className="glass-overlay"
										initial={{ opacity: 0 }}
										animate={{ opacity: 1 }}
										exit={{ opacity: 0 }}
										transition={{ duration: 0.8 }}
									/>
								</>
							)}
						</AnimatePresence>
						<form>
							<div className="d-flex flex-column">
								{/* Avatar Audio Section */}
								<div className="rounded bg-white shadow-sm mb-4 border ">
									<div className="avt-card-title py-3 px-3 border-bottom bg-light rounded">
										<h5 className="m-0">Avatar Audio</h5>
									</div>
									<div className="col-md-12">
										<div className="px-3 my-3 rounded">
											<div className="row g-3">
												<div className="col-md-12">
													<label className="form-label">
														Avatar Voice{" "}
														<HiMiniSpeakerWave
															className="ms-2 fs-5 cursor-pointer"
															onClick={() => setVoicePreviewModelActive(true)}
														/>
													</label>
													<select
														className="form-select form-control"
														name="voice"
														value={avatarConfig.values.voice || ""}
														onChange={avatarConfig.handleChange}
														onBlur={avatarConfig.handleBlur}
														style={{ fontSize: "0.875rem" }}
													>
														<option value=""> Please select a voice</option>
														{voices.map((voice, index) => (
															<option key={index} value={voice.ids}>
																{voice.name} - {voice.gender}
															</option>
														))}
													</select>
													{avatarConfig.touched.voice &&
														avatarConfig.errors.voice && (
															<div className="text-danger small">
																{avatarConfig.errors.voice}
															</div>
														)}
												</div>
												<Accordion className="mb-3">
													<Accordion.Item eventKey="0">
														<Accordion.Header>
															<RiEditBoxLine className="fs-6 me-2" /> Advanced
															parameters
														</Accordion.Header>
														<Accordion.Body>
															<div className="row">
																{/* Speed */}
																<div className="col-4">
																	<label className="form-label">
																		Speed ({bookDetail.speed || 1.0})
																	</label>
																	<input
																		type="range"
																		className="form-range"
																		name="speed"
																		min="0.25"
																		max="4"
																		step="0.05"
																		value={bookDetail.speed || 1.0}
																		onChange={(e) => {
																			avatarConfig.handleChange(e);
																			updateTrackStyle(e.target, 0.25, 4)
																			setBookDetail({
																				...bookDetail,
																				speed: e.target.value,
																			})
																				;
																		}}
																		onBlur={avatarConfig.handleBlur}
																		title={bookDetail.speed}
																		style={{
																			"--progress": `${((bookDetail.speed - 0.25) /
																				(4 - 0.25)) *
																				100
																				}%`,
																		}}
																	/>
																</div>

																{/* Pitch */}
																<div className="col-4">
																	<label className="form-label">
																		Pitch ({bookDetail.pitch || 0.0})
																	</label>
																	<input
																		type="range"
																		className="form-range"
																		name="pitch"
																		min="-20"
																		max="20"
																		step="0.5"
																		value={bookDetail.pitch || 0.0}
																		onChange={(e) => {
																			avatarConfig.handleChange(e);
																			updateTrackStyle(e.target, -20, 20);
																			setBookDetail({
																				...bookDetail,
																				pitch: e.target.value,
																			})
																		}}
																		onBlur={avatarConfig.handleBlur}
																		title={bookDetail.pitch}
																		style={{
																			"--progress": `${((bookDetail.pitch - -20) /
																				(20 - -20)) *
																				100
																				}%`,
																		}}
																	/>
																</div>

																{/* Volume Gain */}
																<div className="col-4">
																	<label className="form-label">
																		Volume Gain (dB) (
																		{bookDetail.volume_gain || 0.0})
																	</label>
																	<input
																		type="range"
																		className="form-range"
																		name="volumeGain"
																		min="-96"
																		max="16"
																		step="1"
																		value={bookDetail.volume_gain || 0.0}
																		onChange={(e) => {
																			avatarConfig.handleChange(e);
																			updateTrackStyle(e.target, -96, 16);
																			setBookDetail({
																				...bookDetail,
																				volume_gain: e.target.value,
																			})
																		}}
																		onBlur={avatarConfig.handleBlur}
																		title={avatarConfig.values.volumeGain}
																		style={{
																			"--progress": `${((bookDetail.volume_gain -
																				-96) /
																				(16 - -96)) *
																				100
																				}%`,
																		}}
																	/>
																</div>
															</div>
														</Accordion.Body>
													</Accordion.Item>
												</Accordion>
											</div>
										</div>
									</div>
								</div>

								{/* Text Highlight Style Section */}
								<div className="rounded bg-white shadow-sm border">
									<div className="avt-card-title py-3 px-3 border-bottom bg-light rounded">
										<h5 className="m-0">Text Highlight Style</h5>
									</div>
									<div className="col-md-12 ">
										<div className="px-3 my-3 rounded">
											<div className="row g-3">
												<div className="col-md-6">
													<div className="row">
														<div className="col-md-12 my-2">
															<label className="form-label">Text color</label>
															<MuiColorInput
																format="hex"
																value={bookDetail.text_color || "#0000"}
																onChange={handleTextColorChange}
															/>
														</div>
														<div className="col-md-12 my-2">
															<label className="form-label">
																Text Background
															</label>
															<MuiColorInput
																format="hex"
																value={bookDetail.text_background_color || "#ffffff"}
																onChange={handleBgColorChange}
															/>
														</div>
														<div className="col-md-12 my-2">
															<label htmlFor="fontBold">Font Bold?</label>
															<Android12Switch
																id="fontBold"
																name="fontBold"
																checked={bookDetail.text_bold == "true" ? true : false}
																onChange={(e) => handleBold(e)}
															/>
														</div>
													</div>
												</div>
												<div className="col-md-6 d-flex align-items-center justify-content-center">
													<div className="border rounded p-3 w-75 h-75 text-center">
														<p>
															Lorem ipsum, dolor sit{" "}
															<span
																style={{
																	color: bookDetail.text_color,
																	backgroundColor: bookDetail.text_background_color,
																	fontWeight: bookDetail.text_bold == "true"
																		? "600"
																		: "normal",
																}}
															>
																amet consectetur adipisicing elit. Explicabo,
															</span>{" "}
															expedita!
														</p>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</form>
					</div>
				</div>
				<div className="col-md-6">
					<div className="overlay-enable">
						<AnimatePresence>
							{!enableAvatar && (
								<>
									{enableAudio && (
										<motion.div
											className="button_avatar-enable"
											initial={{ opacity: 0, y: -10 }}
											animate={{ opacity: 1, y: 0 }}
											exit={{ opacity: 0, y: -10 }}
											transition={{ duration: 0.8 }}
										>
											<label htmlFor="enableAvatar">
												Want to enable Avatar
											</label>
											<Android12Switch
												id="enableAvatar"
												name="enableAvatar"
												checked={enableAvatar}
												onChange={(e) => setEnableAvatar(e.target.checked)}
											/>
										</motion.div>
									)}

									<motion.div
										className="glass-overlay"
										initial={{ opacity: 0 }}
										animate={{ opacity: 1 }}
										exit={{ opacity: 0 }}
										transition={{ duration: 0.8 }}
									/>
								</>
							)}
						</AnimatePresence>
						<div
							className="card p-4"
							style={{
								maxHeight: "618px",
								minHeight: "618px",
								overflowY: "scroll",
								overflowX: "hidden",
								scrollbarWidth: "thin",
							}}
						>
							<h6
								className="pb-2 border-bottom-2 mb-3"
								style={{ width: "fit-content", borderBottom: "1px solid #000" }}
							>
								All Avatars
							</h6>
							<div className="row">
								<div className="col-md-4">
									<div
										className="card w-100 border"
										style={{ backgroundColor: "aliceblue" }}
									>
										<div
											style={{
												height: "185px",
												border: "1px solid #000",
												borderRadius: "15px",
											}}
										>
											<div
												{...getRootProps()}
												className={`dropzone pointer h-100 d-flex flex-column align-items-center justify-content-center ${isDragActive ? "active" : ""
													}`}
											>
												<input {...getInputProps()} />
												<FaRegPlusSquare
													size={25}
													className="upload-icon mb-2"
												/>
												<p style={{ fontSize: "13px" }} className="mb-2">
													Upload New
												</p>
												<p style={{ fontSize: "13px" }} className="mb-2">
													Supports png
												</p>
											</div>
										</div>
									</div>
								</div>
								{avatars.map((avatar, index) => (
									<AvatarCard
										key={index}
										col={4}
										avatar={avatar}
										handleAvatarSelection={handleAvatarSelection}
										base_url={base_url}
									/>
								))}
								{hasMoreAvatarLoadMore && (
									<div className="row text-center mt-4">
										<div className="col-md-4 mt-4"><Button variant="contained" color="secondary" style={{ width: "140px" }} onClick={handleLoadMoreAvatar}>Load more</Button></div>
									</div>
								)}
							</div>
						</div>
					</div>
				</div>
				{voicePreviewModelActive && (
					<div
						className="filter-image-model position-absolute d-flex justify-content-center align-items-start"
						onClick={(e) => {
							if (e.target.className.includes("filter-image-model")) {
								closeModel();
							}
						}}
					>
						<div className="filter-image-model-inner ">
							<div
								className="d-flex justify-content-between align-items-center mb-2 btn-container gap-2 p-4"
								style={{ backgroundColor: "#c9d9f04a" }}
							>
								<h4 className="ps-2 mb-0">Preview your voices</h4>
								<button className="btn btn-sm btn-primary" onClick={closeModel}>
									<MdClose />
								</button>
							</div>
							<div
								className="d-flex justify-content-center flex-wrap gap-2"
								style={{
									maxHeight: "515px",
									overflow: "scroll",
									scrollbarWidth: "none",
								}}
							>
								<div className="container mt-4">
									<div className="table-responsive">
										<table className="table table-bordered table-striped">
											<thead className="table-dark">
												<tr>
													<th>Language</th>
													<th>Voice Type</th>
													<th>Language Code</th>
													<th>Voice Name</th>
													<th>SSML Gender</th>
													<th>Sample</th>
												</tr>
											</thead>
											<tbody>
												{voices.map((voice, index) => (
													<tr key={index}>
														<td>{voice.language_name}</td>
														<td>{voice.engine}</td>
														<td>{voice.language_code}</td>
														<td>{voice.name}</td>
														<td>{voice.gender}</td>
														<td>
															<audio controls>
																<source
																	src={`https://cloud.google.com/static/text-to-speech/docs/audio/${voice.name}.wav`}
																	type="audio/mpeg"
																/>
																Your browser does not support the audio element.
															</audio>
														</td>
													</tr>
												))}
											</tbody>
										</table>
									</div>
								</div>
							</div>
						</div>
					</div>
				)}
			</div>
		</>
	);
};

export default AvatarPage;
